export function deletar(fetch, id) {
  return fetch().delete("/fabricante/" + id);
}

export function getAll(fetch) {
  return fetch().get("/fabricante");
}

export function getDetalhe(fetch, id) {
  return fetch().get("/fabricante/" + id);
}

export function put(fetch, loja) {
  return fetch().put("/fabricante", loja);
}
export function post(fetch, loja) {
  return fetch().post("/fabricante", loja);
}
